<div class="ui-modal">
  <div class="header flex-row space-between-center">
    {{ (persons.length === 1 ? 'PERSONS.SAVE_PERSON_COUNT' : 'PERSONS.SAVE_PERSONS_COUNT') | translate: { count: persons.length } }}
    <span class="ui-icon-close c-p" (click)="closeDialog()"></span>
  </div>
  <div class="body flex-col start-start flex gap-16 dialog-content narrower-input">
    <div class="flex-col gap-16 w-100">
      @for (person of persons; track person.bucketId; let index = $index) {
        <div class="person-row">
          <img
            class="person-row-image"
            [appAuthSrc]="getImagePath(person)"
            [appAuthSrcFallback]="getImagePath(person, false)"
            alt="User photo"
          >
          <div class="flex-col gap-8 w-100">
            <label [for]="'person-name-' + person.bucketId">{{ 'PERSONS.PERSON_NAME' | translate }}</label>
            <input
              [id]="'person-name-' + person.bucketId"
              type="text"
              [formControl]="personNameForms.controls[index]"
              [placeholder]="'PERSONS.PERSON_NAME' | translate"
              class="ui-input ui-input-40"
            >
          </div>
        </div>
      }
    </div>
  </div>
  <div class="footer flex-row end-center gap-8">
    <ui-button
      type="secondary"
      [text]="'PERSONS.ADD_TO_GROUP' | translate"
      [disabled]="!arePersonNamesValid() || isBulkCreatingPendingPersons()"
      (clickAction)="openAddPersonToGroupsDialog()"
    ></ui-button>
    <ui-button
      type="primary"
      [text]="'COMMON.SAVE' | translate"
      [disabled]="!arePersonNamesValid()"
      [loading]="isBulkCreatingPendingPersons()"
      (clickAction)="savePersons()"
    ></ui-button>
  </div>
</div>
